import { isEmpty } from "lodash";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import * as StyledCommon from "./Common.styled";
import * as Styled from "./RadioInput.styled";

export type RadioInputProps = {
    disabled?: boolean;
    error?: boolean;
    name: string;
    value: string | boolean;
    label: string;
    isRequired?: boolean;
    id: string;
    subLabel?: string;
    labelClickable?: boolean;
    LabelTextComponent?: React.ElementType<React.PropsWithChildren<{}>>;
};

export const RadioInput: FC<RadioInputProps> = ({
    disabled,
    name,
    label,
    subLabel,
    id,
    value,
    isRequired,
    labelClickable = true,
    LabelTextComponent = StyledCommon.InputLabel,
    ...rest
}) => {
    const { register, watch } = useFormContext();

    return (
        <Styled.InputRootWrapper>
            <Styled.Radio
                disabled={disabled}
                id={id}
                required={isRequired}
                disableRipple
                color="default"
                checkedIcon={<Styled.CustomCheckedIcon />}
                icon={<Styled.CustomIcon />}
                value={value}
                checked={value === watch(name)}
                {...rest}
                {...register(name)}
            />
            <Styled.InputLabelWrapper>
                {labelClickable ? (
                    <label htmlFor={id}>
                        <LabelTextComponent>{label}</LabelTextComponent>
                    </label>
                ) : (
                    <LabelTextComponent>{label}</LabelTextComponent>
                )}
                {!isEmpty(subLabel) && (
                    labelClickable ? (
                        <label htmlFor={id}>
                            <LabelTextComponent>{subLabel}</LabelTextComponent>
                        </label>
                    ) : (
                        <LabelTextComponent>{subLabel}</LabelTextComponent>
                    )
                )}
            </Styled.InputLabelWrapper>
        </Styled.InputRootWrapper>
    );
};
